// removed by extract-text-webpack-plugin
module.exports = {"NewGrey":"#596067","labelContainer":"Gbb960f","label":"G3d5c04 Gfbbf38","sublabel":"G4a9b65 G19bca4"};